export const getItemsPerPage = <T>(
  list: T[],
  itemsPerPage: number,
  pageNumber: number
) => {
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const endIndex = pageNumber * itemsPerPage;

  return list.slice(startIndex, endIndex);
};
